export default {
  buildingUses: {
    headline: "Building Use Types",
    icon: "mdi-city",
    categories: [
      {
        label: "Residential",
        color: "#FFB121",
      },
      {
        label: "Commercial | Office",
        color: "#F76A6A",
      },
      {
        label: "Public | Daycare",
        color: "#4EBFFC",
      },
    ],
  },
  wind: {
    headline: "Lawson Criteria categories",
    icon: "mdi-windsock",
    labelLowValues: "Comfortable",
    labelHighValues: "Uncomfortable",
    categories: [
      {
        label: "Sitting Long",
        detail: "0.0 - 2.5m/s",
        color: "#458cbf",
      },
      {
        label: "Sitting Short",
        detail: "2.5 - 4.0m/s",
        color: "#95d3e0",
      },
      {
        label: "Walking Slow",
        detail: "4.0 - 6.0m/s",
        color: "#90c363",
      },
      {
        label: "Walking Fast",
        detail: "6.0 - 8.0 m/s",
        color: "#f4ec7d",
      },
      {
        label: "Uncomfortable",
        detail: "8.0 - 10.0 m/s",
        color: "#fbc46f",
      },
      {
        label: "Dangerous",
        detail: ">10.0m/s",
        color: "#ee7679",
      },
    ],
  },
  sunExposure: {
    headline: "Hours of sunlight per day averaged over a year",
    icon: "mdi-circle",
    labelLowValues: "Shady",
    labelHighValues: "Sunny",
    categories: [
      {
        label: "< 1.2 h/day",
        color: "#0571b0",
      },
      {
        label: "1.2 h/day",
        color: "#6aaed1",
      },
      {
        label: "2.4 h/day",
        color: "#b2d5e6",
      },
      {
        label: "3.6 h/day",
        color: "#e7eff3",
      },
      {
        label: "4.8 h/day",
        color: "#f7ece7",
      },
      {
        label: "6 h/day",
        color: "#f6dbcf",
      },
      {
        label: "7.2 h/day",
        color: "#f6cbb7",
      },
      {
        label: "8.4 h/day",
        color: "#f5baa0",
      },
      {
        label: "9.6 h/day",
        color: "#f5a988",
      },
      {
        label: "10.8 h/day",
        color: "#e97867",
      },
      {
        label: "12 h/day",
        color: "#da3c43",
      },
    ],
  },
  noise: {
    headline: "Noise Results in dB [LDEN]",
    labelLowValues: "Quiet",
    labelHighValues: "Noisy",
    icon: "mdi-bullhorn",
    categories: [
      {
        label: "<45dB (A)",
        color: "#B8D6D1",
      },
      {
        label: "45-50dB (A)",
        color: "#CEE4CC",
      },
      {
        label: "50-55dB (A)",
        color: "#E2F2BF",
      },
      {
        label: "55-60dB (A)",
        color: "#F3C683",
        icon: "mdi-circle",
      },
      {
        label: "60-65dB (A)",
        color: "#E87E4D",
      },
      {
        label: "65-70dB (A)",
        color: "#CD463E",
      },
      {
        label: "70-75dB (A)",
        color: "#A11A4D",
      },
      {
        label: ">75dB (A)",
        color: "#75085C",
      },
    ],
  },
  stormwater: {
    headline: "Run Off Times",
    icon: "mdi-bullhorn",
    categories: [
      {
        label: "<45dB (A)",
        color: "#B8D6D1",
      },
      {
        label: "45-50dB (A)",
        color: "#CEE4CC",
      },
      {
        label: "50-55dB (A)",
        color: "#E2F2BF",
      },
      {
        label: "55-60dB (A)",
        color: "#F3C683",
        icon: "mdi-circle",
      },
      {
        label: "60-65dB (A)",
        color: "#E87E4D",
      },
      {
        label: "65-70dB (A)",
        color: "#CD463E",
      },
      {
        label: "70-75dB (A)",
        color: "#A11A4D",
      },
      {
        label: ">75dB (A)",
        color: "#75085C",
      },
    ],
  },
  accessibility: {
    headline: "Distance to nearest destination",
    icon: "mdi-accessibility",
    labelLowValues: "0–100 m",
    labelHighValues: "≥1000 m",
    // below is the original legend for the accessibility layer
    // categories: [
    //   {
    //     label: "0–100 m ~1–2 min walk",
    //     color: "#da3c43",
    //   },
    //   {
    //     label: "100–200 m ~2–3 min walk",
    //     color: "#e97867",
    //   },
    //   {
    //     label: "200–300 m ~4–5 min walk",
    //     color: "#f5a988",
    //   },
    //   {
    //     label: "300–400 m ~5–6 min walk",
    //     color: "#f5baa0",
    //   },
    //   {
    //     label: "400–500 m ~6–8 min walk",
    //     color: "#f6cbb7",
    //   },
    //   {
    //     label: "500–600 m ~7–9 min walk",
    //     color: "#f6dbcf",
    //   },
    //   {
    //     label: "600–700 m ~8–11 min walk",
    //     color: "#f7ece7",
    //   },
    //   {
    //     label: "700–800 m ~10–12 min walk",
    //     color: "#e7eff3",
    //   },
    //   {
    //     label: "800–900 m ~11–14 min walk",
    //     color: "#b2d5e6",
    //   },
    //   {
    //     label: "900–1000 m ~12–15 min walk",
    //     color: "#6aaed1",
    //   },
    //   {
    //     label: "≥1000 m ~≥12–15 min walk",
    //     color: "#0571b0",
    //   },
    // ],
    // Alternative: Viridis palette (commented out)
    categories: [
      { label: "0–100 m ~1–2 min walk", color: "#FDE725" },
      { label: "100–200 m ~2–3 min walk", color: "#B5DE2B" },
      { label: "200–300 m ~4–5 min walk", color: "#6ECE58" },
      { label: "300–400 m ~5–6 min walk", color: "#35B779" },
      { label: "400–500 m ~6–8 min walk", color: "#1F9E89" },
      { label: "500–600 m ~7–9 min walk", color: "#26838F" },
      { label: "600–700 m ~8–11 min walk", color: "#31688E" },
      { label: "700–800 m ~10–12 min walk", color: "#3B528B" },
      { label: "800–900 m ~11–14 min walk", color: "#46327E" },
      { label: "900–1000 m ~12–15 min walk", color: "#440154" },
      { label: "≥1000 m ~≥12–15 min walk", color: "#2D004B" },
    ],
    // Alternative: Turbo palette (commented out)
    // categories: [
    //   { label: "0–100 m ~1–2 min walk", color: "#E71D36" },
    //   { label: "100–200 m ~2–3 min walk", color: "#F05A28" },
    //   { label: "200–300 m ~4–5 min walk", color: "#F6A02D" },
    //   { label: "300–400 m ~5–6 min walk", color: "#F6E944" },
    //   { label: "400–500 m ~6–8 min walk", color: "#B7F34A" },
    //   { label: "500–600 m ~7–9 min walk", color: "#5BE65A" },
    //   { label: "600–700 m ~8–11 min walk", color: "#2DCB7C" },
    //   { label: "700–800 m ~10–12 min walk", color: "#1FA187" },
    //   { label: "800–900 m ~11–14 min walk", color: "#2F6B8E" },
    //   { label: "900–1000 m ~12–15 min walk", color: "#3B4CC0" },
    //   { label: "≥1000 m ~≥12–15 min walk", color: "#30123B" },
    // ],
    // Alternative: Blue→Red palette (commented out)
    // categories: [
    //   { label: "0–100 m ~1–2 min walk", color: "#FF0000" },
    //   { label: "100–200 m ~2–3 min walk", color: "#FF4000" },
    //   { label: "200–300 m ~4–5 min walk", color: "#FF8000" },
    //   { label: "300–400 m ~5–6 min walk", color: "#FFBF00" },
    //   { label: "400–500 m ~6–8 min walk", color: "#FFFF00" },
    //   { label: "500–600 m ~7–9 min walk", color: "#BFFF00" },
    //   { label: "600–700 m ~8–11 min walk", color: "#80FF00" },
    //   { label: "700–800 m ~10–12 min walk", color: "#40FF00" },
    //   { label: "800–900 m ~11–14 min walk", color: "#00FF00" },
    //   { label: "900–1000 m ~12–15 min walk", color: "#0080FF" },
    //   { label: "≥1000 m ~≥12–15 min walk", color: "#0000FF" },
    // ],
  },
};
